import { ApiUrlTypes } from "../client-switcher.js";
import { CentrifugePrivateClient } from "./ws-private.client.js";
import { CentrifugePublicClient } from "./ws-public.client.js";
const wsTokenRefreshEndpoint = "/api/web-sockets/get-token";
const wsRegistrationTokenRefreshEndpoint = "/api/web-sockets/get-session-token";
const clientsWs = [
  {
    key: "wsClient",
    client: {
      ClientConstructor: CentrifugePublicClient,
      url: ApiUrlTypes.platform
    }
  },
  {
    key: "wsRegistrationPrivateClient",
    client: {
      tokenRefresh: wsRegistrationTokenRefreshEndpoint,
      ClientConstructor: CentrifugePrivateClient,
      url: ApiUrlTypes.platform
    }
  },
  {
    key: "wsPrivateClient",
    client: {
      tokenRefresh: wsTokenRefreshEndpoint,
      ClientConstructor: CentrifugePrivateClient,
      url: ApiUrlTypes.platform
    }
  }
];
export {
  clientsWs
};
